import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import Card from './Card';

const AboutMe: React.FC = () => {
  return (
    <Card title="About" index={1}>
      <div className="space-y-6 text-neutral-700 dark:text-neutral-300">
        <p className="text-lg leading-relaxed">
          I'm a senior software engineer with 5+ years of experience across frontend and full-stack development. I focus on building scalable enterprise applications — currently working on salesforce automation, virtual POS, and bank integration modules at Alpata Teknoloji using .NET and Angular.
        </p>
        <p className="text-lg leading-relaxed">
          Before Alpata, I spent over a year at ETIYA building Angular interfaces for one of Europe's largest telecom providers, and four years at Rapider AI as a frontend lead — architecting a low-code BPMN diagram builder and shipping full-stack features with Loopback4 alongside a team of four. My background spans payment integrations, complex state management, and translating business requirements into reliable software.
        </p>
        <motion.div
          className="pt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          <a
            href="/Bugra-Ozdilek-Software-Engineer-CV-EN.pdf"
            download="BugraOzdilek_Resume.pdf"
            className="inline-flex items-center gap-2 border border-neutral-300 dark:border-neutral-700 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-neutral-800 dark:text-neutral-200 hover:border-accent hover:text-accent transition-colors"
          >
            <span>[ Download Resume.pdf ]</span>
            <Download className="h-3.5 w-3.5" />
          </a>
        </motion.div>
      </div>
    </Card>
  );
};

export default AboutMe;
